var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9408 8.22215L10.6892 0.18309C10.6225 0.125051 10.5434 0.0790049 10.4563 0.0475881C10.3692 0.0161712 10.2758 0 10.1815 0C10.0872 0 9.99387 0.0161712 9.90677 0.0475881C9.81966 0.0790049 9.74054 0.125051 9.67393 0.18309L0.422266 8.22215C0.152734 8.45653 0 8.77489 0 9.10692C0 9.79637 0.644629 10.3569 1.4375 10.3569H2.41231V16.0932C2.41231 16.4389 2.7335 16.7182 3.13106 16.7182H8.74404V12.3432H11.2597V16.7182H17.232C17.6296 16.7182 17.9508 16.4389 17.9508 16.0932V10.3569H18.9256C19.3074 10.3569 19.6735 10.2261 19.9431 9.98973C20.5023 9.50145 20.5023 8.71043 19.9408 8.22215V8.22215Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon);
export default __webpack_public_path__ + "static/media/homeicon.8678f7c9.svg";
export { ForwardRef as ReactComponent };